import {
    booleanAttribute,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DestroyRef,
    inject,
    input,
    ViewEncapsulation,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DialogService } from '@pixelgenau/ngx-dialog';
import { switchMap } from 'rxjs';
import { M000C010ImageComponent } from '../../000-primitives/m000-c010-image/m000-c010-image.component';
import { ImageAiFocus } from '../../000-primitives/m000-c010-image/m000-c010-image.interface';
import { ChildM030C90GalleryOverlayDialogTag } from './child-m030-c090-gallery-overlay/child-m030-c090-gallery-overlay.dialog';
import type { M030C090GalleryImage } from './m030-c090-gallery.interface';

@Component({
    selector: 'ui-m030-c090-gallery',
    standalone: true,
    templateUrl: './m030-c090-gallery.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [M000C010ImageComponent],
})
export class M030C90GalleryComponent {
    images = input.required<M030C090GalleryImage[]>();
    caption = input<string>();
    isFirstView = input.required({ transform: booleanAttribute });
    protected readonly dialogService = inject(DialogService);
    protected readonly cdr = inject(ChangeDetectorRef);
    protected readonly destroyRef = inject(DestroyRef);

    ImageAiFocus = ImageAiFocus;

    async openGallery(image: string): Promise<void> {
        this.dialogService
            .openDialog(ChildM030C90GalleryOverlayDialogTag, {
                image,
            })
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                switchMap((result) => result.close$),
            )
            .subscribe(() => {
                // MW vorrübergehend genehmigt
                // eslint-disable-next-line @rx-angular/no-explicit-change-detection-apis
                this.cdr.detectChanges();
            });
    }
}
